import RequestCard from './RequestCard.jsx';
import { AnimatePresence, motion } from 'framer-motion';

export default function RequestList({
  requests,
  passagePercents,
  onBoost,
  onOpenSuggest,
  paidQueueUiEnabled = true,
}) {
  const maxPassagePercent = passagePercents
    ? Math.max(0, ...Object.values(passagePercents).map((p) => Number(p) || 0))
    : 0;

  if (!requests || requests.length === 0) {
    return (
      <motion.div
        className="card mt-4 text-center"
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <p className="text-3xl" aria-hidden>🎶</p>
        <p className="mt-2 text-sm font-semibold text-white/85">
          La file est vide — lance la soirée !
        </p>
        <p className="mt-1 text-xs text-white/55">
          {paidQueueUiEnabled
            ? 'Sois le premier à suggérer un son. Les autres pourront voter et ajouter un montant.'
            : 'Sois le premier à suggérer un son, puis invite les autres à voter.'}
        </p>
        {onOpenSuggest ? (
          <button
            type="button"
            onClick={onOpenSuggest}
            className="btn-primary mt-4 min-h-[44px] px-5 py-2.5 text-sm font-semibold"
          >
            + Suggérer une musique
          </button>
        ) : null}
      </motion.div>
    );
  }

  return (
    <ul className="mt-4 flex flex-col gap-2.5">
      <AnimatePresence initial={false}>
        {requests.map((req, i) => (
          <RequestCard
            key={req.id}
            request={req}
            rank={i + 1}
            passagePercent={passagePercents?.[req.id]}
            maxPassagePercent={maxPassagePercent}
            onBoost={onBoost}
            paidQueueUiEnabled={paidQueueUiEnabled}
          />
        ))}
      </AnimatePresence>
    </ul>
  );
}
